var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Header'),_c('v-main',{staticClass:"mt-14",attrs:{"id":"main-container"}},[_c('v-container',{staticClass:"main-container"},[_c('NotificationContainer'),_c('router-view',{key:_vm.$route.path})],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }